import * as tslib_1 from "tslib";
import selectSenderOnTopOption from '../actions/selectSenderOnTopOption';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var MessageListFull = /** @class */ (function (_super) {
    tslib_1.__extends(MessageListFull, _super);
    function MessageListFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSenderOnTopChange = function (ev, option) {
            selectSenderOnTopOption(option.key === 'true');
        };
        return _this;
    }
    MessageListFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var senderOnTop = getFallbackValueIfNull(optionStore.showSenderOnTopInListView, userOptions.ShowSenderOnTopInListView);
        return (React.createElement(ChoiceGroup, { selectedKey: "" + senderOnTop, options: [
                {
                    key: 'true',
                    text: strings.options_messageList_firstLineSender,
                },
                {
                    key: 'false',
                    text: strings.options_messageList_firstLineSubject,
                },
            ], onChange: this.onSenderOnTopChange, label: strings.options_messageList_firstLineLabel }));
    };
    MessageListFull = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], MessageListFull);
    return MessageListFull;
}(React.Component));
export default MessageListFull;
//# sourceMappingURL=SenderSubjectFull.js.map